export var TokenKind;
(function (TokenKind) {
    TokenKind["ACCESS"] = "accessToken";
    TokenKind["REFRESH"] = "refreshToken";
    TokenKind["ID"] = "idToken";
})(TokenKind || (TokenKind = {}));
